module.exports = __webpack_public_path__ + "img/keyboard-02.7835ed97.svg";